// extracted by mini-css-extract-plugin
export default {"noteContainer":"NoteInput_noteContainer__DH79U","noteWrapper":"NoteInput_noteWrapper__M+Tz9","noteInput":"NoteInput_noteInput__CgDBD"};